/**
 * @Author: chengzh
 * @Date:   2021-06-02 20:47:28
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-08-10 18:02:58
 */
// import { defineMessages, useIntl } from 'react-intl';
import Head from 'next/head';
import Header from './Header/Header';
import Footer from './Footer/index';
import myContext from '@/utils/createContext';
import QueryString from 'query-string';
import { Divider } from 'antd';

import '@/static/style/index.less';
import '@/static/style/antd-custom.less';
import { useContext } from 'react';
import { injectIntl } from 'react-intl/dist/index';

// const messages = defineMessages({
//   title: {
//     id: 'title',
//     defaultMessage: '',
//   },
// });

function Layout (props) {
  const { hideFooter, children, hideFooterCancelPayment } = props;
  let styleObj = {};
  if (typeof window !== "undefined") {
   styleObj = QueryString.parse(window.location.search);
  }
  const { backgroundColor } = styleObj;
  const _backgroundColor = backgroundColor ? backgroundColor : '#f8f8f8';
  const { resData, isMobileView, key } = useContext(myContext);
  // const intl = useIntl();
  return (
    <>
      <Head>
        <meta
          name='viewport'
          content='width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no,viewport-fit=cover'
        />
        {/* <title>{title || intl.formatMessage(messages.title)}</title> */}
        <title>Secure Checkout</title>
      </Head>
      <div id="vh5pc">
        {children}
        {hideFooter ? '' : <Footer resData={resData} isMobileView={isMobileView} key={key} hideFooterCancelPayment={hideFooterCancelPayment}/>}
      </div>
    </>
  );
}

export default Layout;
